import React from "react";
import "../styles.css";

function Description({value}) {
  //console.log(value)
    return (
    <div className="description">
     <div className="inner">
         <hr/>

    <h1>{value.snippet.channelTitle}</h1>
    <h5><strong>Title: </strong>{value.snippet.title}</h5>
      <hr/>
      <p>
       {value.snippet.description}
      </p>
      </div>
    </div>
  );
}

export default Description;
